/**
 * Backend return seconds so we chop them
 * @param time
 * @returns {string}
 */
export const formatFlightTime = time => time?.substr(0, 5);
